import {SpecModel, SpecModelConfig, SpecReducer} from '../spec/SpecModel';
import {seriesLabel} from './ChartSpecBuilder';
import {applyOps, ChartSpecOp, describeOps, findSeries, normalizeSpec} from './ChartSpecOps';
import {ChartSpec, ChartSpecCapabilities, ChartSpecSeries} from './ChartSpecTypes';

export type ChartSpecModelConfig = SpecModelConfig<ChartSpec, ChartSpecCapabilities>;

const chartSpecReducer: SpecReducer<ChartSpec, ChartSpecOp, ChartSpecCapabilities> = {
    applyOps,
    normalizeSpec,
    describeOps,
    replaceOp: spec => ({op: 'replaceSpec', spec})
};

/**
 * Owns the ChartSpec for one chart - see SpecModel for dispatch and undo. The configurator, the AI
 * assistant and legend clicks all change it through `dispatch()`.
 */
export class ChartSpecModel extends SpecModel<ChartSpec, ChartSpecOp, ChartSpecCapabilities> {
    constructor(config: ChartSpecModelConfig) {
        super(chartSpecReducer, config);
    }

    getSeries(field: string): ChartSpecSeries {
        return findSeries(this.spec, field);
    }

    seriesLabel(field: string): string {
        const series = this.getSeries(field);
        return series ? seriesLabel(series, this.catalog) : this.fieldLabel(field);
    }
}
